export function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";
  for (i = 0; i < 3; i += 1) {
    const value = Math.min((hash >> (i * 8)) & 0xff, 255);
    color += `00${Math.round(value).toString(16)}`.slice(-2);
  }

  return color;
}
